export default "__VITE_ASSET__CD1vcVct__"